






















































































































































































































































import Vue from "vue";
import { Watch, Component, Prop } from "vue-property-decorator";
import { BookingsCard, Membership, Poster, FilesCard } from "@/components";
import { BookingResource, UserResource } from "@/resources";
import { User, Store, Booking, File } from "@/resources/interfaces";
import LogsCard from "@/components/LogsCard.vue";
import CopyId from "@/components/CopyId.vue";
import MergeCustomerCard from "@/components/MergeCustomerCard.vue";

@Component({
  components: {
    BookingsCard,
    Membership,
    Poster,
    FilesCard,
    LogsCard,
    CopyId,
    MergeCustomerCard
  }
})
export default class UserProfile extends Vue {
  user: Partial<User> = { tags: [] };
  userBookings: Booking[] = [];

  activatedAt: Date = new Date();

  showMergeCustomerDialog = false;

  @Prop({ default: false })
  add!: boolean;

  get readonly() {
    if (
      !this.$user.can("CUSTOMER") &&
      this.user.tags &&
      this.user.tags.includes("pr")
    ) {
      return true;
    }
    return false;
  }

  get creatable() {
    return !this.user.id && this.user.mobile?.length === 11;
  }

  get userValidated() {
    if (!this.user.mobile || this.user.mobile.length !== 11) return false;
    return true;
  }

  async update(field: keyof User, value: any) {
    this.user = await UserResource.update(
      { id: this.user.id },
      { [field]: value.map((f: File) => f.id) }
    );
  }

  async save() {
    this.user = await UserResource.save(this.user);
    this.$notify({
      message: "保存成功",
      icon: "check",
      type: "success"
    });
    if (this.add) {
      this.$destroy();
      this.$router.replace(`/user/${this.user.id}`);
    }
  }

  async getUser() {
    this.user = await UserResource.get({ id: this.$route.params.id });
    return this.user;
  }

  async getBookings() {
    this.userBookings = await BookingResource.query({
      customer: this.user.id,
      limit: 50
    });
  }

  createBooking(type = "play") {
    this.$router.push(`/booking/${type}/add?customer=${this.user.id}`);
  }

  storeName(storeId: string) {
    return this.$stores.find(s => s.id === storeId)?.name || "-";
  }

  async updateYouzanPoints() {
    await UserResource.update(
      { id: this.user.id, updateYouzanPoints: true },
      {}
    );
    this.$notify({
      message: "ZOOJOO商城积分同步完成",
      type: "success",
      icon: "add_alert"
    });
  }

  @Watch("user.mobile") async onUserMobileUpdate() {
    if (!this.user.id && this.user.mobile?.length === 11) {
      const [user] = await UserResource.query({ mobile: this.user.mobile });
      if (user) {
        this.$destroy();
        this.$router.replace(`/user/${user.id}`);
      } else {
        this.$notify({
          message: "没有匹配手机号的客户，请继续创建用户",
          type: "success",
          icon: "add_alert"
        });
      }
    }
  }

  @Watch("user.store") onUserStoreUpdate(store: Store | false) {
    if (typeof store === "object" && store) {
      // @ts-ignore
      this.user.store = this.user.store.id;
    } else if (store === false) {
      this.user.store = null;
    }
  }

  async activated() {
    this.activatedAt = new Date();
    if (!this.add) {
      this.$set(this.user, "id", this.$route.params.id);
      this.getUser();
      this.getBookings();
    }
  }
}
